import * as React from "react";
import { P } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const SolutionsLegalDisclaimer = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(P, null, getLabel("products.solutions.features.disclaimer"));
};
export {
  SolutionsLegalDisclaimer
};
//# sourceMappingURL=SolutionsLegalDisclaimer.js.map
